import is from '@sindresorhus/is';

import type { UserProfileVisibilityResponse } from '~/shared/data-contract/profile-visibility';

export type VisibilityStatus = 'private' | 'public' | 'restricted';

export const getVisibilityStatus = (visibility: UserProfileVisibilityResponse): VisibilityStatus => {
    let visibilityStatus: VisibilityStatus = 'public';

    Object.values(visibility).forEach((value) => {
        if (is.nonEmptyObject(value)) {
            if (value.everyone === false) {
                visibilityStatus = 'private';

                return;
            }
        }
    });

    if (visibilityStatus === 'public') {
        return visibilityStatus;
    }

    Object.values(visibility).forEach((value) => {
        if (is.nonEmptyObject(value)) {
            if (value.everyone === true || is.nonEmptyArray(value.roles)) {
                visibilityStatus = 'restricted';

                return;
            }
        }
    });

    return visibilityStatus;
};
